export default __webpack_public_path__ + "static/media/646.840e5336.png";